export const enLottomaticaservizi = {
  modal: {
    geolocation: {
      content: 'Lottomatica Servizi is about to ask you to access your location for better use of the service.',
      title: 'Geolocation Lottomatica Servizi',
    },
  },
  namespaceTest: 'Hello Lottomatica Servizi',
};
